/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLuggageIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-luggage"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M7.1 21.48Q5.97 21.48 5.21 20.71Q4.45 19.95 4.45 18.82L4.45 7.5Q4.45 6.38 5.21 5.61Q5.97 4.85 7.1 4.85L8.6 4.85L8.6 3.85Q8.6 2.73 9.36 1.96Q10.13 1.2 11.25 1.2L12.75 1.2Q13.88 1.2 14.64 1.96Q15.4 2.73 15.4 3.85L15.4 4.85L16.9 4.85Q18.02 4.85 18.79 5.61Q19.55 6.38 19.55 7.5L19.55 18.82Q19.55 19.95 18.79 20.71Q18.02 21.48 16.9 21.48L16.9 21.48Q16.9 22.02 16.51 22.41Q16.13 22.8 15.57 22.8Q15.03 22.8 14.64 22.41Q14.25 22.02 14.25 21.48L14.25 21.48L9.75 21.48L9.75 21.48Q9.75 22.02 9.36 22.41Q8.97 22.8 8.43 22.8Q7.88 22.8 7.49 22.41Q7.1 22.02 7.1 21.48ZM9.93 8.5Q9.93 8.5 9.65 8.5Q9.38 8.5 8.99 8.89Q8.6 9.28 8.6 9.82L8.6 16.5Q8.6 17.05 8.99 17.44Q9.38 17.82 9.93 17.82Q10.47 17.82 10.86 17.44Q11.25 17.05 11.25 16.5L11.25 9.82Q11.25 9.28 10.86 8.89Q10.47 8.5 9.93 8.5ZM14.07 8.5Q14.07 8.5 13.8 8.5Q13.53 8.5 13.14 8.89Q12.75 9.28 12.75 9.82L12.75 16.5Q12.75 17.05 13.14 17.44Q13.53 17.82 14.07 17.82Q14.63 17.82 15.01 17.44Q15.4 17.05 15.4 16.5L15.4 9.82Q15.4 9.28 15.01 8.89Q14.63 8.5 14.07 8.5ZM11.25 4.85L12.75 4.85L12.75 3.85Q12.75 3.85 12.75 3.85Q12.75 3.85 12.75 3.85L11.25 3.85Q11.25 3.85 11.25 3.85Q11.25 3.85 11.25 3.85Z" fill={color} />
    </svg>
  );
}
